import React from 'react';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../features/app/appSlice';
import {
  getRegisteredEmailAddress,
  getMockEmail,
} from '../features/installer/installerJourneySlice';
import useTitle from '../hooks/useTitle';

const LinkRequested = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'installer.LinkRequested.s20',
    'Link requested - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const installerEmailRedux = useSelector(getRegisteredEmailAddress);
  const emailRedux = useSelector(getMockEmail);
  const sendMail = `mailto:${emailRedux};`;
  const pageModel = (
    <>
      {' '}
      <div className="govuk-panel govuk-panel--confirmation">
        <h1 className="govuk-panel__title">
          {copyProvider.getCopy('installer.LinkRequested.s1', 'Link requested')}
        </h1>
        <h3 className="govuk-panel__body">
          {copyProvider.getCopy(
            'installer.LinkRequested.s2',
            'You have requested the link to create your password'
          )}
        </h3>
      </div>
      <h2 className="govuk-heading-m">
        {' '}
        {copyProvider.getCopy(
          'installer.LinkRequested.s3',
          'What happens next'
        )}
      </h2>
      <p className="govuk-body">
        {copyProvider.getCopy('installer.LinkRequested.s4', 'If ')}
        {installerEmailRedux}
        {copyProvider.getCopy(
          'installer.LinkRequested.s0',
          ' is your installer email registered with OZEV, you will received a link to create your password.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.LinkRequested.s6',
          'It may take a few minutes to arrive.'
        )}
      </p>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'installer.LinkRequested.s7',
          'Get help if you did not receive an email'
        )}
      </h2>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.LinkRequested.s8',
          'If you did not receive the email, you will have to contact DVLA, who administer this service on behalf of OZEV.'
        )}
      </p>
      <h3 className="govuk-heading-m">
        {' '}
        {copyProvider.getCopy('installer.LinkRequested.s9', 'Telephone')}
      </h3>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.LinkRequested.s10',
          ' If you have your OZEV installer number, have it with you when you call.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'installer.LinkRequested.s11',
          'Telephone: 020 7946 0101'
        )}
        <br />
        {copyProvider.getCopy(
          'installer.LinkRequested.s12',
          'Monday to Friday, 9am to 5pm'
        )}
      </p>
      <div className="govuk-link govuk-body">
        <a href="/call-charges">
          {copyProvider.getCopy(
            'installer.LinkRequested.s13',
            'Find out about call charges'
          )}
        </a>
      </div>
      <div className="govuk-!-padding-top-4 govuk-body">
        <h3 className="govuk-heading-m">
          {copyProvider.getCopy('installer.LinkRequested.s14', 'Email')}
        </h3>
        <a href={sendMail}>{emailRedux}</a>
        <p className="govuk-body">
          {copyProvider.getCopy(
            'installer.LinkRequested.s15',
            'We aim to respond within 3 working days'
          )}
        </p>
      </div>
      <div className="govuk-!-padding-top-4">
        <h3 className="govuk-heading-m">
          {' '}
          {copyProvider.getCopy('installer.LinkRequested.s16', 'Webchat')}
        </h3>
        <a className="govuk-link govuk-body" href="/speak-to-advisor">
          {copyProvider.getCopy(
            'installer.LinkRequested.s17',
            'Speak to an advisor now'
          )}
        </a>
        <p className="govuk-body govuk-!-padding-top-4">
          <a href="/placeholder" className="govuk-link">
            {copyProvider.getCopy(
              'installer.LinkRequested.s18',
              'What did you think of this service?'
            )}
          </a>{' '}
          {copyProvider.getCopy(
            'installer.LinkRequested.s19',
            '(takes 30 seconds)'
          )}
        </p>
      </div>
    </>
  );
  return pageModel;
};

export default LinkRequested;
